import Vue from 'vue';
import VueRouter from 'vue-router';
// 1. 导入新的组件
import HomePage from '../views/HomePage.vue';
import StatusPage from '../views/StatusPage.vue';
import AuthPage from '../views/AuthPage.vue';

Vue.use(VueRouter);

// 2. 定义新的路由结构
const routes = [
  {
    path: '/',
    name: 'AuthPage',
    component: AuthPage
  },
  {
    path: '/home', // 登录后进入的主页
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/status', // 显示等待/成功状态的页面
    name: 'StatusPage',
    component: StatusPage,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 3. 保留路由守卫，确保页面安全
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('user-openid');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      next();
    } else {
      next({ name: 'AuthPage' });
    }
  } else {
    next();
  }
});

export default router;